import { CircularProgress } from "@material-ui/core";
import React from "react";

import { StatsSummary } from "../StatsSummary";

interface Props {
    issueCount: number;
    loading: boolean;
}

export function SiteIssuesSummary({ issueCount, loading }: Props) {
    return (
        <>
            <StatsSummary
                label="System Issues Detected"
                count={issueCount}
                attentionToCount={true}
            />
            {loading ? <CircularProgress size={28} /> : <></>}
        </>
    );
}
